module.exports = __webpack_public_path__ + "static/media/1.8c0e2e0e.jpg";